import { SobaSuspense } from 'app/components';
import useSettings from 'app/hooks/useSettings';
import { SobaLayouts } from './index';

const SobaLayout = (props) => {
  const { settings } = useSettings();
  const Layout = SobaLayouts[settings.activeLayout];

  return (
    <SobaSuspense>
      <Layout {...props} />
    </SobaSuspense>
  );
};

export default SobaLayout;
